import { render, staticRenderFns } from "./alert-slider.vue?vue&type=template&id=191523a7&"
import script from "./alert-slider.vue?vue&type=script&lang=tsx&"
export * from "./alert-slider.vue?vue&type=script&lang=tsx&"
import style0 from "./alert-slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports